export const SecureStorageService = {
  saveDataToSecureStorage: async () => {},
  getDataFromSecureStorage: async () => {},
  deleteDataFromSecureStorage: async () => {},
  clearTokens: async () => {},
};
